// extracted by mini-css-extract-plugin
export default {"container":"ValueProps_container__5Oj41","overallBft":"ValueProps_overallBft__ppnVl","overallBft2":"ValueProps_overallBft2__xkuUc","bft":"ValueProps_bft__UgFmb"};